import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { Header } from './header';

const SM_BREAKPOINT = 840;

export function AppLayout() {
  const [isSmScreen, setIsSmScreen] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < SM_BREAKPOINT,
  );
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const sm = window.innerWidth < SM_BREAKPOINT;
      setIsSmScreen(sm);
      if (sm) setIsDrawerOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggle = () => {
    if (isSmScreen) {
      setIsDrawerOpen((prev) => !prev);
    } else {
      setIsCollapsed((prev) => !prev);
    }
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar
        isCollapsed={isCollapsed}
        isSmScreen={isSmScreen}
        isDrawerOpen={isDrawerOpen}
        onCloseDrawer={() => setIsDrawerOpen(false)}
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header isCollapsed={isCollapsed} onToggleSidebar={handleToggle} />
        <main className="bg-(--color-bg-secondary) flex-1 overflow-y-auto p-0 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
